import { render, staticRenderFns } from "./Subheader.vue?vue&type=template&id=2c377c67&"
import script from "./Subheader.vue?vue&type=script&lang=js&"
export * from "./Subheader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/fared/kowamas-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c377c67')) {
      api.createRecord('2c377c67', component.options)
    } else {
      api.reload('2c377c67', component.options)
    }
    module.hot.accept("./Subheader.vue?vue&type=template&id=2c377c67&", function () {
      api.rerender('2c377c67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/subheader/Subheader.vue"
export default component.exports